import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Linkedin, Twitter, Instagram } from 'lucide-react';
import landscape from "../lib/images/landscape logo.png";

const LOGO_HORIZONTAL = landscape;

const footerLinks = {
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    // { name: 'Causaler Hire', path: '/product' },
    { name: 'Contact', path: '/contact' },
  ],
  services: [
    { name: 'Website Development', path: '/services' },
    { name: 'Digital Presence', path: '/services' },
    { name: 'Business Dashboards', path: '/services' },
    { name: 'Automation Tools', path: '/services' },
  ],
};

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1 w-auto">
            <Link to="/" className="inline-block" data-testid="footer-logo">
              <img 
                src={LOGO_HORIZONTAL} 
                alt="Causaler" 
                className="h-15 w-13"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Empowering small businesses with simple, scalable, and affordable tech solutions to grow digitally.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.linkedin.com/company/causaler/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#F5941E] transition-colors duration-300"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              {/* <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#F5941E] transition-colors duration-300"
                data-testid="social-twitter"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#F5941E] transition-colors duration-300"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a> */}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-[#F5941E] transition-colors duration-200"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-slate-400 hover:text-[#F5941E] transition-colors duration-200"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#F5941E] mt-0.5 flex-shrink-0" />
                <a 
                  href="mailto:contact@causaler.com" 
                  className="text-slate-400 hover:text-[#F5941E] transition-colors duration-200"
                  data-testid="footer-email"
                >
                  contact@causaler.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#F5941E] mt-0.5 flex-shrink-0" />
                <span className="text-slate-400">
                  +91 74939 06167
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#F5941E] mt-0.5 flex-shrink-0" />
                <span className="text-slate-400">
                  India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {currentYear} Causaler. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link 
              to="/PrivacyPolicy" 
              className="text-slate-500 hover:text-slate-300 text-sm transition-colors"
              data-testid="footer-privacy"
            >
              Privacy Policy
            </Link>
            <Link 
              to="/TermsOfService" 
              className="text-slate-500 hover:text-slate-300 text-sm transition-colors"
              data-testid="footer-terms"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
